import React, { useState, useEffect } from 'react';
import { tabList as data1 } from './DataSet/MainData';
import Link from 'next/link'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import * as Yup from 'yup';
import { faFacebook, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAtom } from 'jotai'
import { useRouter } from 'next/router';

import { atomWithStorage } from 'jotai/utils'

const r_data = atomWithStorage('reportLocalData', {})


const AccordionSection = dynamic(() => import('../Common/AccordionSection', { ssr: false }));
const CommonPopup = dynamic(() => import('../PopupForm/CommonPopup', { ssr: false }));
const RelatedReport = dynamic(() => import('./RelatedReport', { ssr: false }));

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${year}`;
}

const applySummaryConditions = (summary) => {

    if (!summary) {
        return '';
    }
    // Apply conditions
    summary = summary.replace(/(\t|\n|\v|\f|\r| |\&nbsp;)+/g, ' ');
    summary = summary.replace(/<br>/g, ' ');
    summary = summary.replace(/<h1>/g, '<h1 class="font-semibold">');
    summary = summary.replace(/<h2>/g, '<h2 class="font-semibold text-lg">');
    summary = summary.replace(/<h3>/g, '<h3 class="font-semibold text-md">');
    summary = summary.replace(/<h4>/g, '<h4 class="font-semibold">');
    summary = summary.replace(/<h5>/g, '<h5 class="font-semibold">');
    summary = summary.replace(/<h6>/g, '<h6 class="font-semibold">');
    summary = summary.replace(/<h1><b>/g, '<h1 class="font-semibold">');
    summary = summary.replace(/<h2><b>/g, '<h2 class="font-semibold text-lg">');
    summary = summary.replace(/<h3><b>/g, '<h3 class="font-semibold text-md">');
    summary = summary.replace(/<h4><b>/g, '<h4 class="font-semibold">');
    summary = summary.replace(/<h5><b>/g, '<h5 class="font-semibold">');
    summary = summary.replace(/<h6><b>/g, '<h6 class="font-semibold">');
    summary = summary.replace(/<h1><br>?<b>/g, '<h1 class="font-semibold">');
    summary = summary.replace(/<h2><br>?<b>/g, '<h2 class="font-semibold text-lg">');
    summary = summary.replace(/<h3><br>?<b>/g, '<h3 class="font-semibold text-md">');
    summary = summary.replace(/<h4><br>?<b>/g, '<h4 class="font-semibold">');
    summary = summary.replace(/<h5><br>?<b>/g, '<h5 class="font-semibold">');
    summary = summary.replace(/<h6><br>?<b>/g, '<h6 class="font-semibold">');
    summary = summary.replace(/<h1><br ?\/?><b>/g, '<h1 class="font-semibold">');
    summary = summary.replace(/<h2><br ?\/?><b>/g, '<h2 class="font-semibold text-lg">');
    summary = summary.replace(/<h3><br ?\/?><b>/g, '<h3 class="font-semibold text-md">');
    summary = summary.replace(/<h4><br ?\/?><b>/g, '<h4 class="font-semibold">');
    summary = summary.replace(/<h5><br ?\/?><b>/g, '<h5 class="font-semibold">');
    summary = summary.replace(/<h6><br ?\/?><b>/g, '<h6 class="font-semibold">');
    summary = summary.replace(/<h1><strong>/g, '<h1 class="font-semibold">');
    summary = summary.replace(/<h2><strong>/g, '<h2 class="font-semibold text-lg">');
    summary = summary.replace(/<h3><strong>/g, '<h3 class="font-semibold text-md">');
    summary = summary.replace(/<h4><strong>/g, '<h4 class="font-semibold">');
    summary = summary.replace(/<h5><strong>/g, '<h5 class="font-semibold">');
    summary = summary.replace(/<h6><strong>/g, '<h6 class="font-semibold">');
    summary = summary.replace(/&bull; /g, "");
    summary = summary.replace(/&bull;/g, "");
    summary = summary.replace(/&nbsp;/g, '');
    summary = summary.replace(/<p> <\/p>/g, '');
    summary = summary.replace(/width: 1000px; height: 520px;/g, '');
    summary = summary.replace(/width: 800px; height: 443px;/g, '');
    summary = summary.replace(/style=""/g, '')

    // Update ul elements
    const doc = new DOMParser().parseFromString(summary, 'text/html');
    const ulElements = doc.querySelectorAll('ul');
    const liElements = doc.querySelectorAll('li');
    const imgElements = doc.querySelectorAll('img');
    const iframeElements = doc.querySelectorAll('iframe');
    const tableElements = doc.querySelectorAll('table');
    ulElements.forEach((ulElement) => {
        ulElement.className = 'px-4 mx-4 my-2 list-disc list-outside';
    });
    liElements.forEach((liElement) => {
        liElement.className = 'text-[15px] pb-1';
    });
    imgElements.forEach((imgElement) => {
        imgElement.className = 'w-full md:w-[75%] h-full md:overflow-x-auto overflow-x-scroll block relative md:p-4 p-2 bg-white mx-auto shadow-md my-8';
    });
    iframeElements.forEach((iframeElement) => {
        iframeElement.className = 'w-full md:w-[75%] lg:h-[65vh] h-[40vh]  md:overflow-x-auto overflow-x-scroll block relative md:p-4 p-2 bg-white mx-auto shadow-md my-8';
    });
    tableElements.forEach((tableElement) => {
        tableElement.className = 'relative block w-full h-full p-2 mx-auto my-8 overflow-x-scroll bg-white shadow-md md:overflow-x-auto md:p-4';
    });

    return doc.body.innerHTML;
};



const printGeographies = (geographies) => {
    let geo = "";
    let eu4_uk = "";
    geographies?.map((data, index) => {
        if (data.value != "7MM[US ,EU5(Italy ,Spain ,UK ,Germany & France) and Japan]" && data.value != "7MM[US ,EU4(Italy ,Spain ,Germany & France) & UK and Japan]") {
            if(data.value === "EU4 & UK"){
                eu4_uk = data.value;
            }else{
                geo = geo + " " + data.value + ","
            }
        }
    });
    geo = geo + " " + eu4_uk + ","
    var trim = geo.replace(/(^,)|(,$)/g, "")
    return trim;
}
export default function BasicTabs({ data }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [TableOfContent, setTableOfContent] = useState('');
    const [ListOfTables, setListOfTables] = useState('');
    const [ListOfFigures, setListOfFigures] = useState('');
    const [KeyCompanies, setKeyCompanies] = useState('');
    const [ImageInfographics, setImageInfographics] = useState(false);
    const router = useRouter();
    const [keywords, setKeywords] = useAtom(r_data);
    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)
    const [key, setKey] = useState(0);

    useEffect(() => {
        const handleRouteChange = () => {
            setKey(prevKey => prevKey + 1);
        };

        router.events.on('routeChangeComplete', handleRouteChange);

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);



    const faqs = (data.Faqs_data?.faqs)?.map((data, index) => {
        const finalData = {
            title: data.question,
            description: data.answer
        }
        return finalData
    })

    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const options = {
        btn_name: "Submit"
    }
    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'

        }
    ];
    const [tags, setTags] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {
        setIsLoading(false)
        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);



    useEffect(() => {
        if (scrolled > 20) {
            setScrolledStatus(true)
        }
    }, [scrolled])


    useEffect(() => {
        const tagsArray = data?.report_data?.keywords.split(',').map((tag) => tag.trim());
        setKeywords({
            id: data?.report_data?._id,
            keywords: data?.report_data?.keywords
        })
        setTags(tagsArray)
        if (data?.report_data) {
            if (localStorage.getItem('recent_reports')) {
                let existing_reports = JSON.parse(localStorage.getItem('recent_reports'));
                if (typeof existing_reports == 'object') {
                    let keys = Object.keys(existing_reports);
                    if (!keys.includes(data?.report_data?._id)) {
                        if (Object.keys(existing_reports).length > 2) {
                            delete existing_reports[keys[0]];
                        }
                        existing_reports[data?.report_data?._id] = {
                            id: data?.report_data?._id,
                            image: (data?.report_data?.featured_image) ? process.env.IMG_CDN + data?.report_data?.featured_image : process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg',
                            name: data?.report_data?.name,
                            slug: data.report_data?.slug,
                            description: data.report_data?.description,
                            published_date: data?.report_data?.published_on
                        }
                        localStorage.setItem('recent_reports', JSON.stringify(existing_reports))
                    }
                } else {
                    let recent_obj = {};
                    recent_obj[data?.report_data?._id] = {
                        id: data?.report_data?._id,
                        image: (data?.report_data?.featured_image) ? process.env.IMG_CDN + data?.report_data?.featured_image : process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg',
                        name: data?.report_data?.name,
                        slug: data.report_data?.slug,
                        description: data.report_data?.description,
                        published_date: data?.report_data?.published_on
                    }
                    localStorage.setItem('recent_reports', JSON.stringify(recent_obj))
                }
            } else {
                let recent_obj = {};
                recent_obj[data?.report_data?._id] = {
                    id: data?.report_data?._id,
                    image: (data?.report_data?.featured_image) ? process.env.IMG_CDN + data?.report_data?.featured_image : process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg',
                    name: data?.report_data?.name,
                    slug: data.report_data?.slug,
                    description: data.report_data?.description,
                    published_date: data?.report_data?.published_on
                }
                localStorage.setItem('recent_reports', JSON.stringify(recent_obj))
            }
        }
    }, [data])

    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index, type) => {

        const applyTableOfContent = (table_of_content) => {
            if (!table_of_content) {
                return '';
            }
            // Apply conditions
            table_of_content = table_of_content.replace(/(\t|\n|\v|\f|\r| |\&nbsp;)+/g, " ");
            table_of_content = table_of_content.replace(/<br>/g, " ");
            table_of_content = table_of_content.replace(/<br\/?>/g, "");
            table_of_content = table_of_content.replace(/&bull; /g, "");
            table_of_content = table_of_content.replace(/&bull;/g, "");

            // Update ul elements
            const doc = new DOMParser().parseFromString(table_of_content, 'text/html');
            const ulElements = doc.querySelectorAll('ul');
            const liElements = doc.querySelectorAll('li');
            ulElements.forEach((ulElement) => {
                ulElement.className = 'px-4 mx-4 my-2 list-disc list-outside';
            });
            liElements.forEach((liElement) => {
                liElement.className = 'text-[15px] pb-2';
            });

            return doc.body.innerHTML;
        };
        const applyListOfTables = (list_of_tables) => {
            if (!list_of_tables) {
                return '';
            }
            // Apply conditions
            list_of_tables = list_of_tables.replace(/<p>/g, "<li>");
            list_of_tables = list_of_tables.replace(/<\/p>/g, "</li>");
            list_of_tables = list_of_tables.replace(/<li><strong>List\s*Of\s*Table<\/strong><\/li>/gi, "");
            list_of_tables = list_of_tables.replace(/<li><strong>List\s*of\s*Table<\/strong><\/li>/gi, "");
            list_of_tables = list_of_tables.replace(/<li><strong>List\s*of\s*Tables<\/strong><\/li>/gi, "");
            list_of_tables = list_of_tables.replace(/<li><strong>List\s*Of\s*Tables<\/strong><\/li>/gi, "");
            list_of_tables = list_of_tables.replace(/(\t|\n|\v|\f|\r| |\&nbsp;)+/g, " ");
            list_of_tables = list_of_tables.replace(/<br>/g, " ");
            list_of_tables = list_of_tables.replace(/<br\/?>/g, "");
            list_of_tables = list_of_tables.replace(/&bull; /g, "");
            list_of_tables = list_of_tables.replace(/&bull;/g, "");
            list_of_tables = list_of_tables.replace(/&nbsp;/g, "");
            list_of_tables = list_of_tables.replace(/List of Tables/g, "");
            list_of_tables = list_of_tables.replace(/<b><\/b>/g, "");
            list_of_tables = list_of_tables.replace(/<li class="text-[15px] pb-2"><\/li>/g, "");

            // Update ul elements
            const doc = new DOMParser().parseFromString(list_of_tables, 'text/html');
            const ulElements = doc.querySelectorAll('ul');
            const liElements = doc.querySelectorAll('li');
            ulElements.forEach((ulElement) => {
                ulElement.className = 'px-4 mx-4 my-2 list-disc list-outside';
            });
            liElements.forEach((liElement) => {
                liElement.className = 'text-[15px] pb-2';
            });

            return doc.body.innerHTML;
        };
        const applyListOfFigures = (list_of_figures) => {
            if (!list_of_figures) {
                return '';
            }
            // Apply conditions
            list_of_figures = list_of_figures.replace(/<p>/g, "<li>");
            list_of_figures = list_of_figures.replace(/<\/p>/g, "</li>");
            list_of_figures = list_of_figures.replace(/<li><strong>List\s*of\s*Figures<\/strong><\/li>/gi, "");
            list_of_figures = list_of_figures.replace(/<li><strong>List\s*of\s*Figure<\/strong><\/li>/gi, "");
            list_of_figures = list_of_figures.replace(/<li><strong>List\s*Of\s*Figures<\/strong><\/li>/gi, "");
            list_of_figures = list_of_figures.replace(/<li><strong>List\s*Of\s*Figure<\/strong><\/li>/gi, "");
            list_of_figures = list_of_figures.replace(/(\t|\n|\v|\f|\r| |\&nbsp;)+/g, " ");
            list_of_figures = list_of_figures.replace(/<br>/g, " ");
            list_of_figures = list_of_figures.replace(/<br\/?>/g, "");
            list_of_figures = list_of_figures.replace(/&bull; /g, "");
            list_of_figures = list_of_figures.replace(/&bull;/g, "");
            list_of_figures = list_of_figures.replace(/&nbsp;/g, "");
            list_of_figures = list_of_figures.replace(/List of Figures/g, "");
            list_of_figures = list_of_figures.replace(/<b><\/b>/g, "");
            list_of_figures = list_of_figures.replace(/<li class="text-[15px] pb-2"><\/li>/g, "");

            // Update ul elements
            const doc = new DOMParser().parseFromString(list_of_figures, 'text/html');
            const ulElements = doc.querySelectorAll('ul');
            const liElements = doc.querySelectorAll('li');
            ulElements.forEach((ulElement) => {
                ulElement.className = 'px-4 mx-4 my-2 list-disc list-outside';
            });
            liElements.forEach((liElement) => {
                liElement.className = 'text-[15px] pb-2';
            });

            return doc.body.innerHTML;
        };
        const applyKeyCompanies = (key_companies_toc) => {
            if (!key_companies_toc) {
                return '';
            }
            // Apply conditions
            key_companies_toc = key_companies_toc.replace(/<p>/g, "<li>");
            key_companies_toc = key_companies_toc.replace(/<\/p>/g, "</li>");
            key_companies_toc = key_companies_toc.replace(/(\t|\n|\v|\f|\r| |\&nbsp;)+/g, " ");
            key_companies_toc = key_companies_toc.replace(/&bull; /g, "");
            key_companies_toc = key_companies_toc.replace(/&bull;/g, "");
            key_companies_toc = key_companies_toc.replace(/&nbsp;/g, " ");
            key_companies_toc = key_companies_toc.replace(/color:black/g, "");
            key_companies_toc = key_companies_toc.replace(/color: black;/g, "");
            key_companies_toc = key_companies_toc.replace(/font-size: 11pt;/g, "");
            key_companies_toc = key_companies_toc.replace(/line-height: normal;/g, "");
            key_companies_toc = key_companies_toc.replace(/font-family: Calibri/g, "");
            key_companies_toc = key_companies_toc.replace(/'sans-serif';/g, "");
            key_companies_toc = key_companies_toc.replace(/<span style="">/g, "");
            key_companies_toc = key_companies_toc.replace(/<span style=" ">/g, "");
            key_companies_toc = key_companies_toc.replace(/\s/g, " ");
            // key_companies_toc = key_companies_toc.replace(/\,/g, "</br>");
            key_companies_toc = key_companies_toc.replace(/<br> /g, "<li>");
            key_companies_toc = key_companies_toc.replace(/<br\/?>/g, "<li>");
            key_companies_toc = key_companies_toc.replace(/<liclass\/?>/g, "<li class>");
            key_companies_toc = key_companies_toc.replace(/class/g, " class");


            // Update ul elements
            const doc = new DOMParser().parseFromString(key_companies_toc, 'text/html');
            const ulElements = doc.querySelectorAll('ul');
            const liElements = doc.querySelectorAll('li');
            ulElements.forEach((ulElement) => {
                ulElement.className = 'px-4 mx-4 my-2 list-disc list-outside';
            });
            liElements.forEach((liElement) => {
                liElement.className = 'text-[15px] pb-2';
            });

            return doc.body.innerHTML;
        };

        if (type === "table_of_content" && data.report_data?.content?.table_of_content) {
            const sanitizedTOC = applyTableOfContent(data.report_data?.content?.table_of_content);
            setTableOfContent(sanitizedTOC)
        } else if (type === "list_of_tables" && data.report_data?.content?.list_of_tables) {
            const sanitizedListOfTables = applyListOfTables(data.report_data?.content?.list_of_tables);
            setListOfTables(sanitizedListOfTables)
            const sanitizedListOfFigures = applyListOfFigures(data.report_data?.content?.list_of_figures);
            setListOfFigures(sanitizedListOfFigures)

        } else if (type === "key_companies_toc" && data.report_data?.content?.key_companies_toc) {
            const sanitizedKeyCompaniesTOC = applyKeyCompanies(data.report_data?.content?.key_companies_toc);
            setKeyCompanies(sanitizedKeyCompaniesTOC)
        } else if (type === "image" && data.Infographics_data?.image) {
            setImageInfographics(true)
        }
        setActiveTab(index);
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const sanitizedSummary = applySummaryConditions(data.report_data?.content?.summary);

    const extractContent = (inputString) => {
        const marketInsightsRegex = /-?\s?Market Insight/i;
        const pipelineRegex = /-?\s?Pipeline/i;

        const marketInsightsMatch = inputString.match(marketInsightsRegex);
        const pipelineMatch = inputString.match(pipelineRegex);

        if (marketInsightsMatch || pipelineMatch) {
            const matchIndex = marketInsightsMatch
                ? marketInsightsMatch.index
                : pipelineMatch.index;

            return inputString.substring(0, matchIndex).trim();
        }

        return inputString;
    };

    const ShareSocial = (share_type) => {
        let url = window.location.href;
        if (share_type == 'facebook') {
            url = encodeURI(url);
            let base_url_fb = `https://www.facebook.com/sharer/sharer.php?u=${url}`
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
        if (share_type == 'linkedin') {
            let base_url_fb = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
        if (share_type == 'twitter') {
            let base_url_fb = `http://twitter.com/share?url=${url}`
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
    }
    const resultCompanies = extractContent(data?.report_data?.name ? data?.report_data?.name : "Delveinsight");

    return (
        <>
            {(data) &&
                <>
                    <div className='relative p-4 border rounded'>
                        <div className='flex justify-between gap-4'>
                            <section className="relative hidden md:block reportThumb">
                                <div className="mainTitleImgThumb reportBoxImgBook">
                                    <Image
                                        // priority={true}
                                        className="cursor-pointer reportBoxMainImg"
                                        src={(data?.report_data?.featured_image) ? process.env.IMG_CDN + data?.report_data?.featured_image : process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg'}
                                        alt={data?.report_data?.featured_image_alt ? data.report_data?.featured_image_alt : 'Report Image DelveInsight'}
                                        width={123}
                                        height={174}
                                    />
                                    <section className="mainTitleFrontImg"></section>
                                    {/* <span className='absolute text-white bg-red-600 z-50 rounded-full py-3 px-2 font-semibold text-xs right-0 top-[-15px]'> SALE </span> */}
                                    <Image
                                        // priority={true}
                                        className="cursor-pointer mainTitleBackImg"
                                        src={(data?.report_data?.featured_image) ? process.env.IMG_CDN + data?.report_data?.featured_image : process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg'}
                                        alt={data.report_data?.featured_image_alt ? data.report_data?.featured_image_alt : 'Report Image DelveInsight'}
                                        width={123}
                                        height={174}
                                    />
                                    {data?.report_data?.is_sale == true &&
                                        <div className="absolute left-0 px-3 py-4 text-xs font-semibold text-white bg-red-500 rounded-full -top-4">
                                            SALE
                                        </div>
                                    }
                                </div>
                            </section>
                            <div className='relative w-full'>
                                <p className='my-0 mb-2 text-lg font-semibold line-clamp-2'>
                                    {data?.report_data?.name}
                                </p>
                                <div className='flex flex-wrap'>
                                    <div className='pr-2 md:pr-8'>
                                        <span className='font-semibold'>Published Date : </span>
                                        <span>
                                            {formatDate(data?.report_data?.published_on)}
                                        </span>
                                    </div>
                                    <div className='pr-2 md:pr-8'>
                                        <span className='font-semibold'>Pages : </span>
                                        <span> {data?.report_data?.pages} </span>
                                    </div>
                                    {/* <div className='pr-2 md:pr-8'>
                                        <span className='font-semibold'>Delivery Time : </span>
                                        <span> {data?.report_data?.delivery_time}</span>
                                    </div>
                                    */}
                                    <div className='pr-2 md:pr-8'>
                                        <span className='font-semibold'>Region : </span>
                                        <span>
                                            {/* {
                                                data?.report_data?.geographies.map((data, index, array) => {
                                                    return (<span key={index}>
                                                        {data.value === "7MM[US ,EU5(Italy ,Spain ,UK ,Germany & France) and Japan]" ? null : <>{data.value + ", "}</>}
                                                    </span>)
                                                })
                                            } */}
                                            {printGeographies(data?.report_data?.geographies)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="hidden w-12 md:block group">
                                <Image
                                    // priority={true}
                                    className="w-16 h-16 cursor-pointer"
                                    src={process.env.IMG_CDN + '/mainAssets/assets/images/icons/svg-icons/share.svg'}
                                    alt='Share'
                                    width={2000}
                                    height={2000}
                                />
                                <div className="absolute z-40 hidden w-40 bg-white shadow-lg" id="dropdown-menu">
                                    <ul>
                                        <li className="flex justify-between px-4 py-2 cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('facebook')}>
                                            <span>Facebook</span>
                                            <FontAwesomeIcon className='text-[#1877F2] p-1' icon={faFacebook} />
                                        </li>
                                        <li className="flex justify-between px-4 py-2 cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('twitter')}>
                                            <span>Twitter</span>
                                            <FontAwesomeIcon className='text-[#00acee] p-1' icon={faTwitter} />
                                        </li>
                                        <li className="flex justify-between px-4 py-2 cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('linkedin')}>
                                            <span>LinkedIn</span>
                                            <FontAwesomeIcon className='text-[#0072b1] p-1' icon={faLinkedin} />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {data?.report_data?.is_sale == true &&
                                <div className="absolute left-0 block px-3 py-1 text-xs font-semibold text-white bg-red-500 rounded-tr-lg rounded-bl-lg -top-2 lg:hidden">
                                    SALE
                                </div>
                            }
                        </div>
                        <div className="flex items-center justify-end my-2 md:hidden">
                            <p className='pr-2 m-0 font-semibold'> Share:</p>
                            <Link className='bg-[#0077b5] rounded py-1 px-2 mr-4' target="_blank" href="https://in.linkedin.com/company/delveinsight-business-research-llp" aria-label="linkedin">
                                <i className="text-white fa-brands fa-linkedin"></i>
                            </Link>
                            <Link className='bg-[#1DA1F2] rounded py-1 px-2 mr-4' target="_blank" href="https://twitter.com/delve_insight" aria-label="twitter">
                                <i className="text-white fa-brands fa-twitter"></i>
                            </Link>
                            <Link className='bg-[#1877F2] rounded py-1 px-2 mr-4' target="_blank" href="https://www.facebook.com/delveinsightindia/" aria-label="facebook">
                                <i className="text-white fa-brands fa-facebook"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="my-4">
                        <ul className="sticky z-10 flex flex-row w-full h-12 p-0 px-0 overflow-hidden text-center list-none bg-white border-b overflow-x-scroll lg:overflow-x-hidden lg:overflow-y-hidden whitespace-nowrap mb-30 pb-14 top-16">
                            {data1?.map((item, index) => (
                                // Render tabs based on data availability
                                (item?.description === "summary" && data.report_data?.content?.summary) ||
                                (item?.description === "table_of_content" && data.report_data?.content?.table_of_content) ||
                                (item?.description === "list_of_tables" && data.report_data?.content?.list_of_tables) ||
                                (item?.description === "key_companies_toc" && data.report_data?.content?.key_companies_toc) ||
                                (item?.description === "image" && data.Infographics_data?.image) ?
                                    <li
                                        key={index}
                                        className={index === activeTab ? "h-12 lg:border-t lg:border-r lg:border-b-8 lg:border-l-8 lg:border-b-white lg:border-l-transparent lg:border-gray-300 mb-[-1px] bg-[#1b5df3] lg:content-[''] text-center text-white flex list-none justify-center items-center md:px-4 p-2 cursor-pointer xl:whitespace-nowrap " : "h-12 first:accordion-buttontext-center flex list-none justify-center items-center lg:px-4 md:py-4 p-2 cursor-pointer xl:whitespace-nowrap "}
                                        onClick={() => handleTabClick(index, item?.description)}>
                                        <span className="block">
                                            {item?.description === "table_of_content" ? (
                                            <>
                                                <span className="block md:hidden">TOC</span> {/* Mobile only */}
                                                <span className="hidden md:block">{item?.title}</span> {/* Tablet and up */}
                                            </>
                                            ) : (
                                            item?.title
                                            )}
                                        </span>
                                        {/* <>
                                            {index === activeTab ? (
                                                <Image
                                                    // priority={true}
                                                    width={2000}
                                                    height={2000}
                                                    src={process.env.IMG_CDN + item?.imageWhite}
                                                    alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                    className="block w-8 h-8 md:hidden"
                                                />
                                            ) : (
                                                <Image
                                                    // priority={true}
                                                    width={2000}
                                                    height={2000}
                                                    src={process.env.IMG_CDN + item?.imageBlue}
                                                    alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                    className="block w-8 h-8 md:hidden"
                                                />
                                            )}
                                        </> */}
                                    </li> :
                                    null
                            ))}
                            <li key="22">
                                <Link href={'/sample-request/' + data.report_data?.slug}>
                                    <ul className='flex items-center justify-center h-12 p-2 leading-8 text-center text-white list-none cursor-pointer md:px-4 xl:whitespace-nowrap'>
                                        <li
                                            className="bg-[#ff0d00] hover:bg-[#e70e02] hightLightBtn1 text-white font-semibold text-center flex list-none justify-center items-center px-4 md:py-2 md:mx-2 p-1 m-0 cursor-pointer xl:whitespace-nowrap">
                                            <span className='block'>Sample Request</span>
                                            {/* <Image
                                                width={2000}
                                                height={2000}
                                                src={process.env.IMG_CDN + '/mainAssets/assets/images/nav-tab/icon/request-for-sample-01.svg'}
                                                alt='DelveInsight'
                                                className="block w-8 h-8 md:hidden"
                                            /> */}
                                        </li>
                                    </ul>
                                </Link>
                            </li>
                        </ul>
                        {
                            (isLoading) ?
                            <div className='border border-t-0'>
                                <div className="flex items-center justify-center min-h-screen">
                                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                </div>
                            </div>
                            :
                            <div className="p-4 border border-t-0 lg:p-8 lg:py-6" suppressHydrationWarning>
                                {data1?.map((item, index) => (
                                    <div
                                        key={index}
                                        id='articleContent'
                                        className={`${index === activeTab ? '' : 'hidden'}`}>
                                        <>
                                            {item?.description === "summary" && data.report_data?.content?.summary ?
                                                <>
                                                    <h1 className='text-xl font-semibold capitalize' suppressHydrationWarning>
                                                        {data.report_data?.h1_title ? data.report_data?.h1_title : (data.report_data?.slug).replace(/-/g, ' ')}
                                                    </h1>
                                                    <div dangerouslySetInnerHTML={{ __html: sanitizedSummary }}></div>

                                                </>
                                                :
                                                ''
                                            }
                                            {item?.description === "table_of_content" && data.report_data?.content?.table_of_content ?
                                                <>
                                                    {/* <p className="bg-[#f5f5f5] font-semibold pl-4 py-1 my-0 mb-4">Tables of Content:</p> */}
                                                    <div dangerouslySetInnerHTML={{ __html: TableOfContent }}></div>

                                                </>
                                                :
                                                ''
                                            }
                                            {item?.description === "list_of_tables" && data.report_data?.content?.list_of_tables ?
                                                <>
                                                    <p className="bg-[#f5f5f5] font-semibold pl-4 py-1 my-0 mb-4">List of Tables:</p>
                                                    <ul dangerouslySetInnerHTML={{ __html: ListOfTables }}></ul>
                                                    <p className="bg-[#f5f5f5] font-semibold pl-4 py-1 my-4">List of Figures:</p>
                                                    <ul dangerouslySetInnerHTML={{ __html: ListOfFigures }}></ul>

                                                </>
                                                :
                                                ''
                                            }
                                            {item?.description === "key_companies_toc" && data.report_data?.content?.key_companies_toc ?
                                                <>
                                                    <p className="bg-[#f5f5f5] font-semibold pl-4 py-1 my-0 mb-4">{resultCompanies} Companies:</p>
                                                    <ul dangerouslySetInnerHTML={{ __html: KeyCompanies }}></ul>

                                                </>
                                                :
                                                ''
                                            }
                                            {item?.description === "image" && data.Infographics_data?.image && ImageInfographics ?
                                                <>
                                                    <section className="infographicBox">
                                                        <div className="infographicItem">
                                                            <img
                                                                // priority={true}
                                                                width={2000}
                                                                height={2000}
                                                                src={process.env.IMG_CDN + data.Infographics_data?.image}
                                                                alt={data.infographics_data?.image_alt ? data.infographics_data?.image_alt : 'Infographics Image'}
                                                                className="w-full h-full"
                                                            />
                                                        </div>
                                                        <div className='flex justify-center mt-5'>
                                                            <button onClick={openModal} className="bg-[#1b5df3] hover:bg-[#1b5df3] text-white font-semibold py-2 px-6 rounded text-sm">
                                                                Download Infographics
                                                            </button>
                                                            <CommonPopup isOpen={isModalOpen} closeModal={closeModal}
                                                                fields={fields}
                                                                options={options}
                                                                page_name="Report Profile Page"
                                                                form_name="download-infographic-form"
                                                                formTitle="Request to Download a Free Inforgraphic"
                                                                endpoint="/enquiry/download-infographics"
                                                                anchor_url={process.env.APP_URL + "/infographics/" + data?.report_data?.slug}
                                                                product_name={data.report_data?.h1_title ? data.report_data?.h1_title : (data.report_data?.slug).replace(/-/g, ' ')}
                                                            />
                                                        </div>
                                                    </section>
                                                </>
                                                :
                                                ''
                                            }


                                        </>
                                    </div>
                                ))}
                                {(faqs) &&
                                    <>
                                        <div className='relative block w-full h-full p-2 mx-auto my-8 bg-white shadow-md md:p-4'>
                                            <div className='p-4 border'>
                                                <h2 className='mb-2 text-lg font-semibold'>Frequently Asked Questions</h2>
                                                <AccordionSection data={faqs} />
                                            </div>
                                        </div>
                                    </>
                                }
                                <h2 className='font-semibold text-lg my-2 text-[#1b5df3]'>
                                    <i className="fa-solid fa-tag"></i> Tags:
                                </h2>
                                <ul className='flex flex-wrap gap-2'>
                                    {tags?.map((data, index) => {
                                        return (
                                            <li className='text-sm leading-10 text-black truncate' key={index}>
                                                {index <= 3 ?
                                                    <span key={index} className='bg-[#ecf4fb] py-2 px-3 dark:text-black  rounded-md'>
                                                        {data.replace(/\s/g, ' ')}
                                                    </span>
                                                    : ''}
                                            </li>
                                        )
                                    })}
                                </ul>

                                {scrolledStatus &&
                                    <RelatedReport key={key} keywords={data?.report_data?.keywords} id={data?.report_data?._id} />
                                }

                                {
                                    data?.Infographics_data?.name ? <><h2 className='font-semibold text-lg text-[#1b5df3] my-2'>Infographics</h2>
                                        {
                                            <div className='flex flex-wrap gap-2'>
                                                <div className='flex w-full gap-4 hover:underline'>
                                                    <Image className='p-1 border' src={process.env.IMG_CDN + data.Infographics_data?.thumb} width="20" height="20" alt={data?.Infographics_data?.thumb_alt} />
                                                    <Link href={process.env.APP_URL + "/infographics/" + data?.Infographics_data?.slug}>{data?.Infographics_data?.name}</Link>
                                                </div>
                                            </div>
                                        }</> : null
                                }


                            </div>
                        }
                    </div>
                </>
            }
        </>
    );
}